const types = {
	//Get Template name
	GET_NON_CONFORMITY_REPORT_START: "GET_NON_CONFORMITY_REPORT_START",
	GET_NON_CONFORMITY_REPORT_SUCCESS: "GET_NON_CONFORMITY_REPORT_SUCCESS",
	GET_NON_CONFORMITY_REPORT_ERROR: "GET_NON_CONFORMITY_REPORT_ERROR",
	GET_NON_CONFORMITY_REPORT_RESET: "GET_NON_CONFORMITY_REPORT_RESET",

	//Create Template name
	CREATE_NON_CONFORMITY_REPORT_START: "CREATE_NON_CONFORMITY_REPORT_START",
	CREATE_NON_CONFORMITY_REPORT_SUCCESS: "CREATE_NON_CONFORMITY_REPORT_SUCCESS",
	CREATE_NON_CONFORMITY_REPORT_ERROR: "CREATE_NON_CONFORMITY_REPORT_ERROR",
	CREATE_NON_CONFORMITY_REPORT_RESET: "CREATE_NON_CONFORMITY_REPORT_RESET",

	//delete Template name
	DELETE_NON_CONFORMITY_REPORT_START: "DELETE_NON_CONFORMITY_REPORT_START",
	DELETE_NON_CONFORMITY_REPORT_SUCCESS: "DELETE_NON_CONFORMITY_REPORT_SUCCESS",
	DELETE_NON_CONFORMITY_REPORT_ERROR: "DELETE_NON_CONFORMITY_REPORT_ERROR",
	DELETE_NON_CONFORMITY_REPORT_RESET: "DELETE_NON_CONFORMITY_REPORT_RESET",

	//update Template name
	UPDATE_NON_CONFORMITY_REPORT_START: "UPDATE_NON_CONFORMITY_REPORT_START",
	UPDATE_NON_CONFORMITY_REPORT_SUCCESS: "UPDATE_NON_CONFORMITY_REPORT_SUCCESS",
	UPDATE_NON_CONFORMITY_REPORT_ERROR: "UPDATE_NON_CONFORMITY_REPORT_ERROR",
	UPDATE_NON_CONFORMITY_REPORT_RESET: "UPDATE_NON_CONFORMITY_REPORT_RESET",

	//single item  name
	SINGLE_NON_CONFORMITY_REPORT_START: "SINGLE_NON_CONFORMITY_REPORT_START",
	SINGLE_NON_CONFORMITY_REPORT_SUCCESS: "SINGLE_NON_CONFORMITY_REPORT_SUCCESS",
	SINGLE_NON_CONFORMITY_REPORT_ERROR: "SINGLE_NON_CONFORMITY_REPORT_ERROR",
	SINGLE_NON_CONFORMITY_REPORT_RESET: "SINGLE_NON_CONFORMITY_REPORT_RESET",
};

export default types;
